import { render } from "./DealtrackerPage.vue?vue&type=template&id=290d10ee&scoped=true"
import script from "./DealtrackerPage.vue?vue&type=script&lang=js"
export * from "./DealtrackerPage.vue?vue&type=script&lang=js"

import "./DealtrackerPage.vue?vue&type=style&index=0&id=290d10ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290d10ee"]])

export default __exports__